'use client';

import { forwardRef, useContext } from 'react';

import { Icon } from '../icon/icon';
import { MenuItemContext } from './context/menu-item.context';
import { menuItemIconRecipe } from './styles/menu-item-icon.styles';
import type { MenuItemIconPropsInterface } from './types/menu-item-icon.types';

/**
 * @since 10.0.0
 */

export const MenuItemIcon = forwardRef<SVGSVGElement, MenuItemIconPropsInterface>(
  (props: MenuItemIconPropsInterface, forwardedRef) => {
    const { anchor, disabled } = useContext(MenuItemContext);
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        ref={forwardedRef}
        data-c11n-component="Menu.ItemIcon"
        data-c11n-version={__C11N_VERSION__}
        css={{
          ...menuItemIconRecipe.raw({ anchor, disabled }),
          ...cssProp,
        }}
        {...rest}
      >
        {children}
      </Icon>
    );
  },
);

MenuItemIcon.displayName = 'Menu.ItemIcon';
